import React from 'react';
import '../styles/subscription.css'; // Import your CSS file for other styles

function SubscribeSection() {
  const divStyle = {
    backgroundImage: 'url(/images/subs.png)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    width: '100%',
    height: '40vh',
    // filter: grayscale(10%);
    filter: 'grayscale(100%)',
  };

  return (
    <div className="div4 text-white absolute" >
    <div style={divStyle}></div>
      <div className="flex flex-col items-center relative -top-44">
        <h1 className="text-[2rem]">Don't Miss A Beat: Your Style Updates Awaits</h1>
        <h2 className="text-[1rem] mt-4">Subscribe to stay informed and stylish</h2>
        <form action="" className="flex flex-row items-center justify-center">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Enter your email"
            className="rounded-lg mt-4"
          />
          <button
            type="submit"
            className="flex flex-row justify-center items-center align-middle rounded-xl ml-4 mt-4"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default SubscribeSection;
